import './ReportList.scss';
import ReportIcon from '../../../images/report-icon.png';
import DeleteIcon from '../../../images/delete-icon.png';
import moment from 'moment';

export const ReportList = ({ reports, showDelete, onDelete, onClick }) => {
  return (
    <div className="report-list">
      {reports.map((report, index) => (
        <ReportItem
          key={index}
          report={report}
          showDelete={showDelete}
          onDelete={onDelete}
          onClick={onClick}
          showSeparator={index !== reports.length - 1}
        />
      ))}
    </div>
  );
};

const ReportItem = ({ report, showDelete, onDelete, onClick, showSeparator }) => {
  return (
    <>
      <div className="report-item">
        <img src={ReportIcon} alt="ReportIcon" />
        <div className="report-item-content" onClick={() => onClick(report.analysisId)}>
          {moment(report.createdAt).format('D MMM YYYY h:mm A')}
        </div>
        {showDelete ? <img src={DeleteIcon} alt="DeleteIcon" onClick={() => onDelete(report.analysisId)} /> : <div className="empty" />}
      </div>
      {showSeparator && <hr />}
    </>
  );
};
